import styled from 'styled-components';

export const Container = styled.div`
  button {
    margin-left: 5px;
  }
`;
